module.exports = (__webpack_public_path__ || '') + "static/images/banner-1f39354ec585df2a612ebc52252feb81.jpg";